import React from 'react';
import './AverageDetailsModal.css';

export default function AverageDetailsModal({ isOpen, onClose, termAverages = [] }) {
    if (!isOpen) return null;

    const hasAnyData = termAverages.some((termEntry) => termEntry.hasData);

    return (
        <div className="average-modal-overlay" onClick={onClose}>
            <div className="average-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="average-modal-header">
                    <div>
                        <h2>Overall Averages by Term</h2>
                        <p>Per-subject breakdown for your dashboard averages.</p>
                    </div>
                    <button type="button" className="average-close-btn" onClick={onClose}>x</button>
                </div>

                <div className="average-modal-body">
                    {!hasAnyData && (
                        <div className="average-empty-state">
                            <p>No term averages are available yet.</p>
                        </div>
                    )}

                    {hasAnyData && (
                        <div className="average-term-sections">
                            {termAverages.map((termEntry) => (
                                <section key={termEntry.term} className="average-term-card">
                                    <div className="average-term-card-header">
                                        <div>
                                            <h3>{termEntry.label}</h3>
                                            <p>
                                                {termEntry.hasData
                                                    ? `${termEntry.subjectCount} subject${termEntry.subjectCount === 1 ? '' : 's'} with captured marks`
                                                    : 'No captured marks yet'}
                                            </p>
                                        </div>
                                        <div className={`average-term-badge${termEntry.hasData ? '' : ' is-empty'}`}>
                                            {termEntry.hasData ? `${termEntry.average}%` : '--'}
                                        </div>
                                    </div>

                                    {termEntry.hasData ? (
                                        <div className="average-term-table-wrap">
                                            <table className="average-term-table">
                                                <thead>
                                                    <tr>
                                                        <th>Subject</th>
                                                        <th>Learners</th>
                                                        <th>Average</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {termEntry.subjects.map((subject) => (
                                                        <tr key={`${termEntry.term}-${subject.id}`}>
                                                            <td>{subject.label}</td>
                                                            <td>{subject.studentCount}</td>
                                                            <td>{subject.average}%</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="average-term-empty-row">
                                            No subject averages available for this term.
                                        </div>
                                    )}
                                </section>
                            ))}
                        </div>
                    )}
                </div>

                <div className="average-modal-footer">
                    <button type="button" className="average-footer-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
}
